export default __webpack_public_path__ + "static/media/person2Kalenday.a3d5a443.png";